var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Fragment, useCallback, useRef, useState } from "react";
import { Typeahead, Highlighter, Menu, MenuItem } from "react-bootstrap-typeahead";
import PropTypes from "prop-types";
import SelectMultiInput from "./MultiSelect";
import SelectSingleInput from "./SingleSelect";

import "./FormSelect.scss";

var FormSelect = function FormSelect(_ref) {
  var size = _ref.size,
      groupBy = _ref.groupBy,
      _ref$labelKey = _ref.labelKey,
      labelKey = _ref$labelKey === undefined ? "label" : _ref$labelKey,
      _ref$selected = _ref.selected,
      selected = _ref$selected === undefined ? [] : _ref$selected,
      options = _ref.options,
      onChange = _ref.onChange,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === undefined ? false : _ref$multiple,
      clearButton = _ref.clearButton,
      noBorder = _ref.noBorder,
      readonly = _ref.readonly,
      onBlur = _ref.onBlur,
      required = _ref.required,
      rest = _objectWithoutProperties(_ref, ["size", "groupBy", "labelKey", "selected", "options", "onChange", "multiple", "clearButton", "noBorder", "readonly", "onBlur", "required"]);

  var _useState = useState(false),
      isDirty = _useState[0],
      setIsDirty = _useState[1];

  var _useState2 = useState(false),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var ref = useRef();

  var defaultFilter = useCallback(function (option, props) {
    if (isDirty) {
      if (!props.text) {
        return true;
      }

      return option[props.labelKey] && option[props.labelKey].toLowerCase().indexOf(props.text.toLowerCase()) !== -1;
    }

    return true;
  }, [isDirty]);

  var onMenuToggle = useCallback(function (isOpen) {
    if (!isOpen) {
      setIsDirty(false);
    }
    setIsOpen(isOpen);
  }, [setIsDirty, setIsOpen]);

  var onInputChange = useCallback(function () {
    if (!isDirty) {
      setIsDirty(true);
    }
  }, [setIsDirty, isDirty]);

  var onClickMenuItem = useCallback(function (e) {
    var optionPath = e.currentTarget.dataset.optionkey;

    if (multiple) {
      if (selected.find(function (item) {
        return item[labelKey] === optionPath;
      })) {
        onChange(selected.filter(function (item) {
          return item[labelKey] !== optionPath;
        }));
      } else {
        var option = options.find(function (item) {
          return item[labelKey] === optionPath;
        });
        onChange([].concat(selected, [_extends({}, option)])); //TODO: implement allow new for multi select
      }
    } else {
        // const existingOption = options.find(
        //   (item) => item[labelKey] === optionPath
        // );
        // if (existingOption) {
        //   onChange([existingOption]);
        // } else {
        //   //new item
        //   onChange([{ [labelKey]: optionPath, value: optionPath }]);
        // }
      }
  }, [options, selected, onChange, multiple, labelKey]);

  var onClickClear = useCallback(function () {
    onChange([]);
  }, [onChange]);
  return React.createElement(Typeahead, _extends({
    className: "select-typeahead " + (noBorder ? "no-border" : ""),
    labelKey: labelKey,
    onInputChange: onInputChange,
    onMenuToggle: onMenuToggle,
    filterBy: defaultFilter //Show menu open when click regardless of value already selected or not
    , options: options,
    onChange: multiple ? function () {} : onChange,
    selected: selected,
    multiple: multiple,
    clearButton: false,
    readonly: readonly
  }, rest, {
    ref: ref,
    renderMenu: function renderMenu(results, menuProps, state) {
      var index = 0;
      var transformedItemObject = void 0;
      if (groupBy) {
        transformedItemObject = results.reduce(function (r, item) {
          var key = item[groupBy] || "~";
          if (r[key]) {
            r[key].push(item);
          } else {
            r[key] = [item];
          }
          return r;
        }, {});
      } else {
        transformedItemObject = { "~": results };
      }

      var items = Object.keys(transformedItemObject).sort().map(function (item) {
        return React.createElement(
          Fragment,
          { key: item },
          item !== "~" ? React.createElement(
            Menu.Header,
            null,
            item !== "~" ? item : " "
          ) : index !== 0 ? React.createElement(Menu.Divider, null) : null,
          transformedItemObject[item].map(function (i, keyIndex) {
            var isSelected = selected.find(function (item) {
              return item[labelKey] === i[labelKey];
            });
            var item = React.createElement(
              MenuItem,
              {
                key: index,
                option: i,
                position: index,
                className: "" + (isSelected ? "selected" : ""),
                onClick: onClickMenuItem,
                "data-optionkey": i[labelKey]
              },
              React.createElement(
                Highlighter,
                { search: state ? state.text : "" },
                (typeof i === "undefined" ? "undefined" : _typeof(i)) === "object" ? i[labelKey] : i
              ),
              React.createElement(
                "span",
                { className: "menu-item-icon" },
                "\u2713"
              )
            );

            index += 1;
            return item;
          })
        );
      });

      return readonly ? null : React.createElement(
        Menu,
        menuProps,
        items
      );
    }
    // renderMenuItemChildren={(option, { labelKey, text }) => {
    //   return (
    //     <Fragment>
    //       <Highlighter search={text}>
    //         {typeof option === "object" ? option[labelKey] : option}
    //       </Highlighter>
    //       <span className="menu-item-icon">✓</span>
    //     </Fragment>
    //   );
    // }}
    , renderInput: function renderInput(props) {
      return multiple ? React.createElement(SelectMultiInput, _extends({}, props, {
        selectedValue: selected,
        size: size,
        clearButton: clearButton,
        onClickClear: onClickClear,
        isOpen: isOpen,
        labelKey: labelKey,
        readonly: readonly,
        onBlur: onBlur,
        required: required
      })) : React.createElement(SelectSingleInput, _extends({}, props, {
        selectedValue: selected,
        size: size,
        clearButton: clearButton,
        onClickClear: onClickClear,
        readonly: readonly,
        onBlur: onBlur,
        required: required
      }));
    }
  }));
};

FormSelect.defaultProps = {
  noBorder: false,
  onBlur: function onBlur() {},
  required: false
};

FormSelect.propTypes = process.env.NODE_ENV !== "production" ? {
  /**group items based on attribute */
  groupBy: PropTypes.string,

  /** selected values */
  selected: PropTypes.array.isRequired,

  /**onChange value */
  onChange: PropTypes.func.isRequired,

  /**Border less */
  noBorder: PropTypes.bool,

  /**onBlur input */
  onBlur: PropTypes.func,

  /**
   * required
   */
  required: PropTypes.bool
} : {};
export default FormSelect;